var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#80C383"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.587 27.4144C16.7669 27.5943 17.0058 27.685 17.2433 27.685C17.4793 27.685 17.7168 27.5957 17.8995 27.4144L29.728 15.5831C30.0907 15.2204 30.0907 14.6347 29.728 14.272C29.3653 13.9093 28.7796 13.9093 28.4169 14.272L17.2433 25.4442L11.5831 19.7883C11.2204 19.4271 10.6332 19.4271 10.272 19.7883C9.90933 20.151 9.90933 20.7381 10.272 21.0994L16.587 27.4144Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circle-tick.a232bf2ffd521f12ec76af3826df9e98.svg";
export { ForwardRef as ReactComponent };